import type { ActionsOfCreators, FeatureHandler } from '../helpers';
import { alerts } from './alerts';
import { notify } from './notify';

export const inputActions = [alerts, notify];

export type InputActions = ActionsOfCreators<typeof inputActions>;

export type InputHandler<T extends InputActions> = FeatureHandler<
  T,
  InputActions
>;
